import React, { useState, useEffect, useCallback } from "react";

import Config from "../../Config";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from "./../../components/panel/panel.jsx";
import swal from "sweetalert";
// import UserProfile from '../UserProfile/UserProfile';
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import { Link, useHistory } from "react-router-dom";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardText,
  CardBody,
  CardTitle,
  CardHeader,
  CardFooter,
  Button,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { CreditCardFilled } from "@ant-design/icons";

const ProfileCertificatesList = () => {
  let history = useHistory();
  const [modalSignupAdd, setmodalSignupAdd] = useState(false);
  const [modalSignupEdit, setmodalSignupEdit] = useState(false);
  const [show, setshow] = useState(false);
  const [_id, set_id] = useState("");
  const [Name, setName] = useState("");
  const [fileName, setfileName] = useState("");
  const [Description, setDescription] = useState("");
  const [CreatedDate, setCreatedDate] = useState("");
  const [CertificateList, setCertificateList] = useState([]);
  const [LogoPath, setLogoPath] = useState(false);
  const [ArticleCertificateID, setArticleCertificateID] = useState("");
  const [filePath, setfilePath] = useState("");
  const [CertificateLogoPath, setCertificateLogoPath] = useState("");
  const [CertificateLogoFile, setCertificateLogoFile] = useState(null);
  const [CertificateLogoFileError, setCertificateLogoFileError] = useState("");
  const [CertificateLogoName, setCertificateLogoName] = useState("");
  const [CertificateName, setCertificateName] = useState("");
  const [CertificateNameError, setCertificateNameError] = useState("");
  const [CertificateFileName, setCertificateFileName] = useState("");
  const [CertificateDescription, setCertificateDescription] = useState("");
  const [CertificateDescriptionError, setCertificateDescriptionError] =
    useState("");
  const [CertificateWebsite, setCertificateWebsite] = useState("");
  const [CertificateWebsiteError, setCertificateWebsiteError] = useState("");
  const [PerPageCount, setPerPageCount] = useState(10);
  const [TotalCount, setTotalCount] = useState(0);
  // const [SortColumnType, setSortColumnType] = useState('Desc');
  const [SortColumnType, setSortColumnType] = useState("Desc");
  const [SortColumn, setSortColumn] = useState("addeddate");
  const [SearchValue, setSearchValue] = useState("");
  const [CurrentPageNo, setCurrentPageNo] = useState(1);
  const [ShowPaggingCount, setShowPaggingCount] = useState(4);
  const [PaginationGroupList, setPaginationGrouplist] = useState([]);
  const [canPreviousPage, setcanPreviousPage] = useState(false);
  const [canNextPage, setcanNextPage] = useState(true);
  const [PaggingList, setPaggingList] = useState([]);
  const [SearchCertificatesname, setSearchCertificatesname] = useState("");
  const [CertificateDocumentpath, setCertificateDocumentpath] = useState([]);
  const [DocumentFile, setDocumentFile] = useState([]);
  console.log("DocumentFile===>", DocumentFile.length);
  const [DocumentFileError, setDocumentFileError] = useState([]);
  const [UserDcoumnetName, setUserDcoumnetName] = useState("");

  const [UpgradepremiumCertificate, setUpgradepremiumCertificate] =
    useState(false);
  const [userLoaded, setUserLoaded] = useState(false);
  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    }
  }, []);

  useEffect(() => {
    setPaggingDDL();
    getPaginationGroup();
  }, [TotalCount]);

  useEffect(() => {
    getDataCertificates();
  }, [PerPageCount, SortColumnType, CurrentPageNo, userLoaded]);

  const getDataCertificates = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    //setTotalCount(0);
    fetch(
      Config.apiUrl +
      "Certificate/SearchPagination?SortingColumnName=" +
      SortColumn +
      "&AscDesc=" +
      SortColumnType +
      "&PageNo=" +
      CurrentPageNo +
      "&PageSize=" +
      PerPageCount +
      "&certificateName=" +
      SearchCertificatesname +
      "&SearchQuery=" +
      SearchValue,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result !== null) {
          if (result.certificateList.length > 0) {
            setTotalCount(result.totalcount);
            setCertificateList(result.certificateList);
          } else {
            setTotalCount(0);
            setCertificateList([]);
          }
        } else {
          setTotalCount(0);
          setCertificateList([]);
        }
      });
    });
  };
  const CertificatesetFile = (event) => {
    setCertificateLogoPath(URL.createObjectURL(event.target.files[0]));
    setCertificateLogoFileError("");
    // let temp = [];
    // let tempCertificatesetFile = [...CertificateLogoFile];
    // temp.push(event.target.files[0]);
    setCertificateLogoFile(event.target.files[0]);
  };

  const DcoumnetNameEdit = (event, i) => {
    let temp = [...CertificateDocumentpath];
    var tempData = CertificateDocumentpath[i];
    tempData.FileName = event.target.value;
    setUserDcoumnetName(event.target.value);
  };
  const CertificatesetFileDocument = (event) => {
    setDocumentFileError("");
    // let temp = [...CertificateDocumentpath];
    let temp = [];
    let tempDocumnetFile = DocumentFile;
    let selectedFile = event.target.files;
    for (let index = 0; index < selectedFile.length; index++) {
      let typeobj = selectedFile[index].type;
      if (typeobj === "application/pdf") {
        const element = URL.createObjectURL(selectedFile[index]);
        let dt = {
          _id: "",
          FileUrl: element,
          FileName: selectedFile[index].name,
        };
        setUserDcoumnetName(selectedFile[index].name);
        temp.push(dt);
        tempDocumnetFile.push(selectedFile[index]);
      } else {
        temp = temp;
        tempDocumnetFile = DocumentFile;
      }
    }
    setCertificateDocumentpath(temp);
    setDocumentFile(tempDocumnetFile);
  };

  const onClickArticleCertificateNameEdit = (item) => {
    let temp = [];
    setCertificateName(item.name);
    setCertificateWebsite(item.website);
    setCertificateLogoPath(Config.contentUrl + item._LogoPath);
    setArticleCertificateID(item._id);
    if (item.documentPath !== null) {
      let dt = {
        _id: "1",
        FileUrl: Config.contentUrl + item.documentPath,
        FileName: item.documentUserName,
      };
      temp.push(dt);
    }

    setCertificateDocumentpath(temp);
    setmodalSignupEdit(true);
  };

  const toggleSignupAdd = () => {
    Certificateclerefrom();
    setmodalSignupAdd(!modalSignupAdd);
  };

  const Certificateclerefrom = () => {
    setCertificateNameError("");
    setUserDcoumnetName("");
    setCertificateLogoPath("");
    setCertificateLogoFileError("");
    setCertificateLogoFile(null);
    setCertificateWebsiteError("");
    setDocumentFileError("");
    setCertificateName("");
    setDocumentFile([]);
    setCertificateWebsite("");
    setCertificateDocumentpath([]);
  };
  const toggleSignupEdit = () => {
    setmodalSignupEdit(!modalSignupEdit);
  };

  const onChangeCertificateName = (event) => {
    setCertificateNameError("");
    setCertificateName(event.target.value);
    // setCertificateNameError("");
    // setCertificateName(event.target.value);
  };
  const onChangeWebsiteName = (event) => {
    setCertificateWebsiteError("");
    // if (event.target.value != null) {
    //     if (!new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?').test(event.target.value)) {
    //         setCertificateWebsiteError("Invalid");
    //         setCertificateWebsite(event.target.value);
    //     }
    //     else {
    //         setCertificateWebsite(event.target.value);
    //     }
    // }
    // else {
    //     setCertificateWebsite(event.target.value);
    // }

    if (
      event.target.value !== null &&
      event.target.value !== "" &&
      event.target.value !== undefined
    ) {
      if (
        !new RegExp(
          "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
        ).test(event.target.value)
      ) {
        setCertificateWebsiteError("Invalid weblink");
        setCertificateWebsite(event.target.value);
      } else {
        setCertificateWebsite(event.target.value);
      }
    } else {
      setCertificateWebsite(event.target.value);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Sr. #",
        accessor: "srno",
        selector: "srno",
        sortable: false,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          return (
            <span className="mb-0" style={{ width: "20px" }}>
              {row.row.original.sr}
            </span>
          );
        },
      },
      {
        Header: "Certificates",
        accessor: "certificates",
        selector: "addeddate",
        sortable: false,
        Cell: (row) => {
          let FullPath = `${Config.contentUrl + row.row.original._LogoPath}`;
          return row.row.original._LogoPath !== null ? (
            //<img src={FullPath} alt="img" style={{ height: '40px' }}></img>
            // <img src="../assets/img/user/user-1.jpg" alt="img" height="50px" />
            <img src={FullPath} alt="img" height="50px" />
          ) : (
            <img
              src="../assets/img/new-Images/images.png"
              alt="img"
              height="50px"
            />
          );
        },
      },
      {
        Header: "Name",
        accessor: "name",
        selector: "name",
        sortable: true,
        headerClassName: "rt-tr-align-right",
      },
      {
        Header: "Website",
        accessor: "website",
        // selector: 'website',
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          {
            return row.row.original.website.length > 0 ? (
              <p>{row.row.original.website}</p>
            ) : (
              <p>N/A</p>
            );
          }
        },
      },
      {
        Header: "Document",
        accessor: "document",
        selector: "document",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          let FullPath = `${Config.contentUrl + row.row.original.documentPath}`;
          {
            return row.row.original.documentPath != null ? (
              <button
                className="btn btn-link"
                onClick={() => downloadDocumentData(FullPath)}
              >
                <img
                  src="../assets/img/new-Images/Pdf.png"
                  style={{ height: "60px" }}
                ></img>
              </button>
            ) : (
              <div className="btn btn-link">
                <img
                  src="../assets/img/new-Images/nopdf.png"
                  style={{ height: "60px" }}
                ></img>
              </div>
            );
          }
        },
      },
      {
        Header: " Added Date",
        accessor: "addeddate",
        selector: "addeddate",
        sortable: true,
        Cell: (row) => {
          let date = new Date(row.row.original.createdDate);
          let dateMDY = `${date.getDate()}-${date.getMonth() + 1
            }-${date.getFullYear()}`;
          return <div style={{ width: "110px" }}>{dateMDY}</div>;
        },
      },
      {
        Header: "Owner",
        accessor: "Owner",
        selector: "Owner",
        sortable: false,
        Cell: (row) => {
          let FullOwnerpath = `${Config.contentUrl + row.row.original.ownerImage
            }`;
          return (
            //<img src={FullPathQrcode} alt="img" style={{ height: '40px' }}></img>
            <div className="data-scroll">
              <img
                src={FullOwnerpath}
                className="rounded-circle"
                style={{ height: "40px", width: "40px" }}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = "../assets/img/new-images/images.png";
                }}
              ></img>
              {/* <img src="../assets/img/user/user-1.jpg" alt="img" style={{ height: '40px', }} className='rounded-circle'></img> */}
              <p className="mb-0">{row.row.original.ownerName}</p>
            </div>
          );
        },
      },

      {
        Header: " Actions",
        accessor: "col13",
        sortable: false,
        Cell: (row) => {
          return (
            <div style={{ width: "100px" }}>
              <button
                type="button"
                className="btn btn-primary btn-sm mr-2"
                onClick={(e) => {
                  onClickArticleCertificateNameEdit(row.row.original);
                }}
              >
                <i className="ion ion-md-create "></i>
              </button>
              <button
                type="button"
                className="btn btn-danger btn-sm"
                onClick={(e) => {
                  ArticleCertificatedelete(row.row.original._id);
                }}
              >
                <i className="fas fa-trash"></i>
              </button>
            </div>
          );
        },
      },
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageOptions,
    toggleAllRowsSelected,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data: CertificateList,
      manualPagination: true,
      sortable: false,
      manualSortBy: true,
    },
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          _id: "selection",
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),

          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const ArticleCertificatedelete = (_id) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Certificate!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        fetch(Config.apiUrl + "Certificate/Delete?id=" + _id, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }).then((result) => {
          result.json().then((resp) => {
            if (resp === true) {
              getDataCertificates();
              swal("Congratulations! Your data deleted successfully.", {
                icon: "success",
              });
            } else {
              swal("Your Certificate Detail is safe!");
            }
          });
        });
      }
    });
  };
  const CertificateDetailsSearch = (itemSearchValue) => {
    const itemlength = itemSearchValue.length;
    if (itemlength > 2) {
      getDataCertificates();
    }
  };
  const handlePageCountChange = (event) => {
    setPerPageCount(event);
    setCurrentPageNo(1);
    if (event >= TotalCount) {
      setcanPreviousPage(false);
      setcanNextPage(false);
    } else {
      setcanPreviousPage(false);
      setcanNextPage(true);
    }
  };
  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);

      return (
        <>
          <input type="checkbox" ref={resolvedRef} {...rest} />
        </>
      );
    }
  );
  const setPaggingDDL = () => {
    var testDDL = [];

    if (TotalCount <= 10) {
      testDDL = [10, TotalCount];
    } else if (TotalCount <= 20) {
      testDDL = [10, 20, TotalCount];
    } else if (TotalCount <= 30) {
      testDDL = [10, 20, 30, TotalCount];
    } else if (TotalCount <= 50) {
      testDDL = [10, 20, 30, 50, TotalCount];
    } else if (TotalCount <= 100) {
      testDDL = [10, 20, 30, 50, 100, TotalCount];
    } else if (TotalCount <= 200) {
      testDDL = [10, 20, 30, 50, 100, 200, TotalCount];
    } else if (TotalCount <= 300) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, TotalCount];
    } else if (TotalCount <= 400) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, 400, TotalCount];
    } else if (TotalCount <= 500) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, 400, 500, TotalCount];
    }

    setPaggingList(testDDL);
  };
  const getPaginationGroup = () => {
    if (TotalCount > 0) {
      let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
      let start = Math.floor((CurrentPageNo - 1) / PerPageCount) * PerPageCount;
      let LastPageNo = Math.ceil(TotalCount / PerPageCount);
      if (PerPageCountobj === 1) {
        setcanPreviousPage(false);
        setcanNextPage(false);
      }
      let testArray = [];
      for (var tt = 1; tt <= TotalCount; tt++) {
        if (
          tt >= CurrentPageNo - ShowPaggingCount &&
          tt <= CurrentPageNo + ShowPaggingCount
        ) {
          if (tt <= LastPageNo) {
            testArray.push(tt);
          }
        }
      }
      setPaginationGrouplist(testArray);
    }
  };

  const handleColumnSort = (event) => {
    setCurrentPageNo(1);
    setcanPreviousPage(false);
    setcanNextPage(true);
    setSortColumn(event.selector);
    let SortType = "Desc";
    if (SortColumnType == "Desc") {
      SortType = "Asc";
    }
    setSortColumnType(SortType);
  };
  const gotoPage = () => {
    if (CurrentPageNo > 1) {
      setCurrentPageNo((CurrentPageNo) => CurrentPageNo - 1);
      let temp = Math.ceil(CurrentPageNo - 1);
      if (temp === 1) {
        setcanPreviousPage(false);
      } else {
        setcanPreviousPage(true);
        setcanNextPage(true);
      }
    }
  };

  const nextPage = () => {
    setCurrentPageNo((CurrentPageNo) => CurrentPageNo + 1);
    setcanPreviousPage(true);
    let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
    let temp = Math.ceil(CurrentPageNo + 1);
    if (temp === PerPageCountobj) {
      setcanNextPage(false);
    }
  };
  const changePage = (event) => {
    const pageNumber = Number(event.target.textContent);
    if (pageNumber === 1) {
      setcanPreviousPage(false);
      setcanNextPage(true);
    } else {
      setcanPreviousPage(true);
    }
    setCurrentPageNo(pageNumber);
    let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);

    if (pageNumber === PerPageCountobj) {
      setcanNextPage(false);
    } else {
      setcanNextPage(true);
    }
  };
  const downloadDocumentData = (filename, myUrl) => {
    window.open(filename, "_blank");
  };
  const ondeleteDocumentFile = (FileID, i) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (FileID != "") {
      fetch(
        Config.apiUrl +
        "Certificate/DeleteDocument?certificateId=" +
        ArticleCertificateID,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            let temp = [...CertificateDocumentpath];
            temp.splice(i, 1);
            setCertificateDocumentpath(temp);
          }
        });
      });
    } else {
      let temp = [...CertificateDocumentpath];
      temp.splice(i, 1);
      setCertificateDocumentpath(temp);
    }
  };

  // const fileUploadCrrtificatLogoPost = (IDObj) => {
  //     if (IDObj != '') {
  //         if (CertificateLogoFile != '' || CertificateLogoFile != null) {
  //             let loginid = localStorage.getItem("loginUserID");
  //             let Auth0token = localStorage.getItem('Auth0token')
  //             const formData = new FormData();
  //             formData.append('body', CertificateLogoFile);
  //             formData.append('fileType', "certificatelogo");
  //             formData.append('targetId', IDObj);
  //             formData.append('externalLink', '');
  //             formData.append('displayOrder', '0');
  //             fetch(Config.apiUrl + "FileUpload/Create",
  //                 {
  //                     headers: {
  //                         "userCompanyID": loginid,
  //                         Authorization: 'Bearer ' + Auth0token,
  //                     },
  //                     method: "POST",
  //                     body: formData
  //                 }).then((result) => {
  //                     result.json().then((resp) => {
  //                         console.log(resp);
  //                         fileUploadCertificatPost(IDObj);
  //                     })
  //                 })

  //         }
  //         else {

  //             if (DocumentFile === "" || DocumentFile === null || DocumentFile.length === 0) {
  //                 getDataCertificates();
  //             }
  //             else {
  //                 fileUploadCertificatPost(IDObj);
  //             }
  //         }
  //     }
  // }
  // const fileUploadCertificatPost = (IDObj) => {
  //     if (IDObj != '') {
  //         if (DocumentFile != '' || DocumentFile != null || DocumentFile.length > 0) {
  //             let loginid = localStorage.getItem("loginUserID");
  //             let Auth0token = localStorage.getItem('Auth0token')
  //             const formDataNew = new FormData();
  //             formDataNew.append('body', DocumentFile[0]);
  //             formDataNew.append('fileType', "certificate");
  //             formDataNew.append('targetId', IDObj);
  //             formDataNew.append('externalLink', '');
  //             formDataNew.append('displayOrder', '0');
  //             fetch(Config.apiUrl + "FileUpload/Create",
  //                 {
  //                     headers: {
  //                         "userCompanyID": loginid,
  //                         Authorization: 'Bearer ' + Auth0token,
  //                     },
  //                     method: "POST",
  //                     body: formDataNew
  //                 }).then((result) => {
  //                     result.json().then((resp) => {
  //                         Certificateclerefrom()
  //                         getDataCertificates();
  //                         console.log(resp);
  //                     })
  //                 })
  //         }
  //     }

  // }
  const fileUploadCrrtificatLogoPost = (IDObj) => {
    if (IDObj != "") {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let UserCompanyId = localStorage.getItem("UserCompanyId");
      if (
        CertificateLogoFile != "" &&
        CertificateLogoFile != null
        //&&
        // CertificateLogoFile.length > 0
      ) {
        console.log("CertificateLogoFile=>", CertificateLogoFile);
        const byte = CertificateLogoFile.size;
        fetch(
          Config.apiUrl +
          "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
          UserCompanyId +
          "&UserFileSize=" +
          byte,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((resp1) => {
            if (resp1 === true || resp1 === "true") {
              const formData = new FormData();
              formData.append("body", CertificateLogoFile);
              formData.append("fileType", "certificatelogo");
              formData.append("targetId", IDObj);
              formData.append("externalLink", "");
              formData.append("displayOrder", "0");
              // setIsloading(true)
              fetch(Config.apiUrl + "FileUpload/Create", {
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                method: "POST",
                body: formData,
              }).then((result) => {
                result.json().then((resp) => {
                  fileUploadCertificatPost(IDObj);
                });
              });
            } else if (resp1 === false || resp1 === "false") {
              swal("oops!", "You not allow add Image", "warning");
            } else {
              alert(resp1);
            }
          });
      } else {
        fileUploadCertificatPost(IDObj);
      }
    } else {
      Certificateclerefrom();
      getDataCertificates();
    }
  };
  const fileUploadCertificatPost = (IDObj) => {
    if (IDObj != "") {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      if (
        DocumentFile !== "" &&
        DocumentFile !== null &&
        DocumentFile.length > 0
      ) {
        console.log("DocumentFile=>", DocumentFile.length);
        let UserCompanyId = localStorage.getItem("UserCompanyId");
        const byte =
          DocumentFile.map((item) => item.size || 0).reduce(
            (prev, curr) => prev + curr,
            0
          ) || 0;
        fetch(
          Config.apiUrl +
          "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
          UserCompanyId +
          "&UserFileSize=" +
          byte,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((resp1) => {
            if (resp1 === true || resp1 === "true") {
              const formDataNew = new FormData();
              formDataNew.append("body", DocumentFile[0]);
              formDataNew.append("fileType", "certificate");
              formDataNew.append("targetId", IDObj);
              formDataNew.append("externalLink", "");
              formDataNew.append("displayOrder", "0");
              fetch(Config.apiUrl + "FileUpload/Create", {
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                method: "POST",
                body: formDataNew,
              }).then((result) => {
                result.json().then((resp) => {
                  Certificateclerefrom();
                  getDataCertificates();
                });
              });
            } else if (resp1 === false || resp1 === "false") {
              swal("oops!", "You not allow add Image", "warning");
            } else {
              alert(resp1);
            }
          });
      } else {
        Certificateclerefrom();
        getDataCertificates();
      }
    } else {
      Certificateclerefrom();
      getDataCertificates();
    }
  };

  const fileUploadCertificatLogoPostUpdate = (IDObj) => {
    if (IDObj != "") {
      if (
        CertificateLogoFile != "" &&
        CertificateLogoFile != null &&
        CertificateLogoFile != ""
      ) {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");
        let UserCompanyId = localStorage.getItem("UserCompanyId");
        const byte = CertificateLogoFile.size;
        fetch(
          Config.apiUrl +
          "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
          UserCompanyId +
          "&UserFileSize=" +
          byte,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((resp1) => {
            if (resp1 === true || resp1 === "true") {
              const formData = new FormData();
              formData.append("body", CertificateLogoFile);
              formData.append("fileType", "certificatelogo");
              formData.append("targetId", IDObj);
              fetch(Config.apiUrl + "FileUpload/Update", {
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                method: "PUT",
                body: formData,
              }).then((result) => {
                result.json().then((resp) => {
                  fileUploadCertificatPostUpdate(IDObj);
                  //getDataCertificates();
                  console.log(resp);
                });
              });
            } else if (resp1 === false || resp1 === "false") {
              swal("oops!", "You not allow add Image", "warning");
            } else {
              alert(resp1);
            }
          });
      } else {
        fileUploadCertificatPostUpdate(IDObj);
      }
    }
  };
  const fileUploadCertificatPostUpdate = (IDObj) => {
    if (IDObj != "") {
      if (
        DocumentFile != "" &&
        DocumentFile != null &&
        DocumentFile.length > 0
      ) {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");
        let UserCompanyId = localStorage.getItem("UserCompanyId");
        const byte =
          DocumentFile.map((item) => item.size || 0).reduce(
            (prev, curr) => prev + curr,
            0
          ) || 0;
        fetch(
          Config.apiUrl +
          "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
          UserCompanyId +
          "&UserFileSize=" +
          byte,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((resp1) => {
            if (resp1 === true || resp1 === "true") {
              const formData = new FormData();
              formData.append("body", DocumentFile[0]);
              formData.append("fileType", "certificate");
              formData.append("targetId", IDObj);
              fetch(Config.apiUrl + "FileUpload/Update?id=" + "", {
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                method: "PUT",
                body: formData,
              }).then((result) => {
                result.json().then((resp) => {
                  getDataCertificates();
                  Certificateclerefrom();
                  console.log(resp);
                });
              });
            } else if (resp1 === false || resp1 === "false") {
              swal("oops!", "You not allow add Image", "warning");
            } else {
              alert(resp1);
            }
          });
      } else {
        getDataCertificates();
      }
    }
  };

  const createDocument = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    if (
      CertificateName === null ||
      CertificateName === undefined ||
      CertificateName === ""
    ) {
      retval = false;
      setCertificateNameError("Certificate Name must be filled out");
    }
    // if (CertificateWebsite === null || CertificateWebsite === undefined || CertificateWebsite === '') {
    //     retval = false;
    //     setCertificateWebsiteError('Website must be filled out')
    // }
    // else {
    //     var re = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
    //     var test = re.test(CertificateWebsite)
    //     if (test === false) {
    //         retval = false;
    //         setCertificateWebsiteError('Enter Valid Website')
    //     }

    // }
    // if (CertificateWebsite.length > 0) {
    //     if (CertificateWebsiteError.length > 0) {
    //         retval = false;
    //         setCertificateWebsiteError(CertificateWebsiteError)
    //     }
    // }
    if (CertificateWebsite.length > 0) {
      if (
        !new RegExp(
          "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
        ).test(CertificateWebsite)
      ) {
        retval = false;
        setCertificateWebsiteError("Enter Valid Website");
      }
    }
    // if (CertificateLogoFile === '' || CertificateLogoFile === null || CertificateLogoFile.length === 0) {
    //     retval = false;
    //     setCertificateLogoFileError("Logo File must be secleted any One");
    // }
    // if (DocumentFile.length === 0) {
    //     retval = false;
    //     setDocumentFileError("Document  File must be secleted One or more");
    // }
    let DataObj = {
      Name: CertificateName,
      Website: CertificateWebsite,
      UserCompanyID: loginid,
    };
    if (retval === true) {
      fetch(
        Config.apiUrl +
        "Certificate/CheckCertificate?id=" +
        "" +
        "&certificateName=" +
        CertificateName,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            fetch(Config.apiUrl + "Certificate/Create", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(DataObj),
            }).then((result) => {
              result.json().then((resp) => {
                if (resp != null) {
                  fileUploadCrrtificatLogoPost(resp._id);
                  swal("Saved", "Certificate is saved.", "success");
                  toggleSignupAdd();
                } else {
                  swal("Sorry!", "Certificate is not saved.", "error");
                }
              });
            });
          } else {
            swal("Your Certificate name already exists !");
          }
        });
      });
    }
  };
  const UpdateCertificate = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    if (
      CertificateName === null ||
      CertificateName === undefined ||
      CertificateName === ""
    ) {
      retval = false;
      setCertificateNameError("Certificate Name must be filled out");
    }
    // if (CertificateWebsite === null || CertificateWebsite === undefined || CertificateWebsite === '') {
    //     retval = false;
    //     setCertificateWebsiteError('Website must be filled out')
    // }
    if (CertificateWebsite.length > 0) {
      // var re = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
      // var test = re.test(CertificateWebsite)
      // if (test === false) {
      //     retval = false;
      //     setCertificateWebsiteError('Enter Valid Website')
      // }
      if (
        !new RegExp(
          "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
        ).test(CertificateWebsite)
      ) {
        setCertificateWebsiteError("Invalid weblink");
        retval = false;
      }
    }

    // if (CertificateDocumentpath.length === 0) {
    //   retval = false;
    //   setDocumentFileError("Document  File must be secleted One");
    // }
    let DataObj = {
      _id: ArticleCertificateID,
      Name: CertificateName,
      Website: CertificateWebsite,
      UserCompanyID: loginid,
    };
    if (retval === true) {
      fetch(
        Config.apiUrl +
        "Certificate/CheckCertificate?id=" +
        ArticleCertificateID +
        "&certificateName=" +
        CertificateName,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            fetch(
              Config.apiUrl + "Certificate/Update?id=" + ArticleCertificateID,
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                body: JSON.stringify(DataObj),
              }
            ).then((result) => {
              result.json().then((resp) => {
                if (resp != null) {
                  fileUploadCertificatLogoPostUpdate(resp._id);
                  setmodalSignupEdit(false);
                  swal("Saved", "Certificate is saved.", "success");
                } else {
                  swal("Sorry!", "Certificate is not saved.", "error");
                }
              });
            });
          } else {
            swal("Your Category name already exists !");
          }
        });
      });
    }
  };

  const ExportDeatlis = () => {
    let TotalIteam = [];
    let Auth0token = localStorage.getItem("Auth0token");
    for (let index = 0; index < selectedFlatRows.length; index++) {
      TotalIteam.push(selectedFlatRows[index].original._id);
    }
    if (TotalIteam.length > 0) {
      fetch(Config.apiUrl + "Certificate/Export", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(TotalIteam),
      })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = "ExportCertificates.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();
          deselectAllRows();
        });
    } else {
      swal("Sorry!", "pleace select certificates !", "error");
    }
  };
  const deselectAllRows = useCallback(() => {
    Object.keys(selectedRowIds).forEach((key, index) => {
      selectedRowIds[key] = false;
    });
    toggleAllRowsSelected(false);
  }, [selectedRowIds, toggleAllRowsSelected]);
  const onSelcetdCertificateDelete = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let TotalIteam = [];
    for (let index = 0; index < selectedFlatRows.length; index++) {
      TotalIteam.push(selectedFlatRows[index].original._id);
    }
    if (TotalIteam.length > 0) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this Certificate !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(
            Config.apiUrl + "Certificate/MultipleDelete?id[]=" + TotalIteam,
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(TotalIteam),
            }
          ).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                getDataCertificates();
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your  Certificate  is safe!");
              }
            });
          });
        }
      });
    } else {
      swal("Sorry!", "pleace select certificate !", "error");
    }
  };
  const onchangedCertificatesSearchName = (event) => {
    setSearchCertificatesname(event.target.value);
  };
  const SearchFilter = () => {
    setCurrentPageNo(1);
    getDataCertificates();
  };

  const ResetHederSearch = () => {
    setSearchCertificatesname("");
    setUserLoaded(!userLoaded);
    //getDataLabel();
  };

  return (
    <div id="main-wrapper">
      <div className="row d-flex justify-content-end mb-2">
        <div className="col-md-12 row justify-content-end">
          <button
            onClick={toggleSignupAdd}
            type="button"
            className="btns btn btn-primary search-btn  mr-2 mt-1"
          >
            <i class="fas fa-lg fa-fw m-r-5 fa-plus-square icon"></i>
            Add new
          </button>

          <button
            className="btn btn-green mr-2 mt-1"
            onClick={(e) => {
              ExportDeatlis();
            }}
          >
            <i class="fas  fa-sm fa-fw m-r-5 fa-download icon"></i>
            Export{" "}
          </button>

          <button
            type="button"
            className="btns btn  btn-danger  mr-2 mt-1"
            onClick={(e) => {
              onSelcetdCertificateDelete(e);
            }}
          >
            <i className="far fa-lg fa-fw m-r-5 fa-trash-alt icon"></i>
            Delete (selected)
          </button>
        </div>
      </div>
      <Panel>
        <PanelHeader>
          <h4 className="mb-0 text-white">
            <i className="fas fa-fw m-r-10 fa-search"></i>
            Search
          </h4>
        </PanelHeader>
        <PanelBody>
          <div className="row align-items-center">
            <div className="col-xl-6 mt-3">
              <form action="" method="POST">
                <fieldset>
                  <div className="form-group row mb-0 align-items-center">
                    <label className="col-md-4 col-lg-3 col-form-label product-lable">
                      Certificate Name{" "}
                    </label>
                    <div className="col-md-8 col-lg-9 ">
                      <input
                        type="text"
                        className="form-control input-height"
                        value={SearchCertificatesname}
                        placeholder="Enter certificate name"
                        onChange={(e) => {
                          onchangedCertificatesSearchName(e);
                        }}
                      />
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
            <button
              type="button"
              className="btn btn-primary search-btn d-flex align-items-center mr-2 mt-3"
              onClick={SearchFilter}
            >
              <i className="fas fa-lg fa-fw m-r-10 fa-search "></i>
              Search
            </button>
            <button
              type="button"
              className="btn btn-danger align-items-center mt-3"
              onClick={(e) => {
                ResetHederSearch();
              }}
            >
              Reset
            </button>
            {/* <div className="col-xl-6 px-4">
              <form action="" method="POST">
                <fieldset>
                  <div className="form-group row m-b-15 d-flex align-items-center">
                    <label className="col-md-4 col-form-label product-lable">
                      Owner
                    </label>
                    <div className="d-none d-md-block d-lg-block">:</div>
                    <div className="col-md-7">
                      <select class="default-select2 form-control">
                        <option value="" disabled selected>
                          Select owner
                        </option>
                        <option value="CA">Yes</option>
                        <option value="NV">No</option>
                      </select>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div> */}
          </div>

        </PanelBody>
      </Panel>
      <Panel>
        <PanelHeader>
          <h4 className="mb-0 text-white">List of Certificates</h4>
        </PanelHeader>
        <PanelBody>
          {/* <div className="row">
                        <div className="col-xl-12 d-flex align-items-center">
                            <button className="btn btn-default  m-r-10">All Certificates</button>
                            <div className="form-group  d-flex mb-0 m-r-10 align-items-center">
                                <label className="col-md-4 col-form-label p-0">All</label>
                                <input type="email" className="form-control col-md-8" id="exampleInputEmail2" onKeyUp={(e) => { CertificateDetailsSearch(e.target.value) }} placeholder={"(" + TotalCount + ")"} />
                            </div>
                            <div className="display">
                                <select
                                    className="form-control"
                                    value={PerPageCount}
                                    onChange={e => {
                                        handlePageCountChange(Number(e.target.value))
                                    }}
                                >
                                    {PaggingList.map(pageSize => {
                                        return pageSize == TotalCount ?
                                            <option key={pageSize} value={pageSize}>
                                                Show All
                                            </option> :
                                            <option key={pageSize} value={pageSize}>
                                                Show {pageSize}
                                            </option>
                                    }
                                    )}
                                </select>
                            </div>
                        </div>
                    </div> */}
          <div class="table-responsive mt-3">
            <table
              class="table table-bordered table-striped text-center"
              {...getTableProps()}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    style={{ textAlign: "center" }}
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        className=""
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        <div class="d-flex" style={{ minWidth: "" }}>
                          <span>{column.render("Header")}</span>
                          <span
                            class="ml-auto"
                            onClick={(e) => {
                              handleColumnSort(column);
                            }}
                          >
                            {column.sortable ? (
                              SortColumn === column.selector ? (
                                SortColumnType == "Desc" ? (
                                  <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                                ) : (
                                  <i className="fa fa-sort-up fa-fw f-s-14 text-blue"></i>
                                )
                              ) : (
                                <i className="fa fa-sort fa-fw f-s-14 opacity-3"></i>
                              )
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()} className="align-middle">
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <div>
              Showing{" "}
              <strong>
                {CurrentPageNo} of {Math.ceil(TotalCount / PerPageCount)}
              </strong>{" "}
              entries
            </div>

            <ul class="pagination justify-content-end flex-wrap align-items-center mt-3">
              <li class="page-item">
                {canPreviousPage == true ? (
                  <a
                    class="page-link mr-2"
                    href="javascript:void(0);"
                    onClick={() => gotoPage(0)}
                  >
                    Previous
                  </a>
                ) : (
                  <a
                    class="page-link mr-2"
                    href="javascript:void(0);"
                    disabled={true}
                  >
                    Previous
                  </a>
                )}
              </li>

              {PaginationGroupList.map((item, index) => (
                <li>
                  <button
                    key={index}
                    onClick={changePage}
                    className={`btn ml-2 ${CurrentPageNo === item ? "page-link-1" : "btn-white"
                      }`}
                  >
                    <span>{item}</span>
                  </button>
                </li>
              ))}

              <li class="page-item ml-2">
                {canNextPage == true ? (
                  <a
                    class="page-link"
                    href="javascript:void(0);"
                    onClick={() => nextPage()}
                  >
                    Next
                  </a>
                ) : (
                  <a
                    class="page-link"
                    href="javascript:void(0);"
                    disabled={true}
                  >
                    Next
                  </a>
                )}
              </li>
            </ul>
          </div>
        </PanelBody>
      </Panel>

      {/* upgrade section */}
      {UpgradepremiumCertificate === true ? (
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-7">
              <Card className="border-0 shadow-add">
                <CardHeader className="f-w-600">
                  You need to upgrade your account
                </CardHeader>
                <CardBody>
                  <CardText>
                    Upgrade your package to premium to add new Certificates . In
                    order to use this feature please{" "}
                    <Link>upgrade your account.</Link>
                  </CardText>
                </CardBody>
                <CardFooter className="text-muted f-w-600">
                  <Button className="shadow-add mx-1" color="primary" size="sm">
                    Upgrade Account
                  </Button>
                  <Button className="shadow-add mx-1" color="danger" size="sm">
                    Back to Home
                  </Button>
                </CardFooter>
              </Card>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}

      {/* upgrade  */}

      <Modal isOpen={modalSignupAdd} toggle={toggleSignupAdd}>
        <ModalHeader toggle={toggleSignupAdd} className="modalheader">
          <h4 className="text-white mb-0">Add Certificates</h4>
        </ModalHeader>
        <ModalBody className="m-0">
          <div className="form-group row m-b-15">
            <h5 className="col-md-3 col-form-label mb-0">Certificates Name</h5>
            <div className="col-md-9">
              <input
                type="text"
                maxLength={40}
                className="form-control"
                placeholder="Enter Name"
                value={CertificateName}
                onChange={onChangeCertificateName}
              />
              <p
                style={{
                  textAlign: "right",
                  fontSize: 12,
                  color: "red",
                }}
              >
                {CertificateName.length}/40
              </p>
              {CertificateNameError.length > 0 ? (
                <span
                  style={{
                    color: "red",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginLeft: "10px",
                  }}
                >
                  {CertificateNameError}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className=" row m-b-15">
            <h5 className="col-md-3 mb-0">Logo</h5>
            <div className="col-md-9">
              <div class="custom-file file-upload-height">
                <input
                  type="file"
                  onChange={(e) => CertificatesetFile(e)}
                  className="custom-file-input file-upload-height"
                  id="customFile"
                />
                <label
                  className=" file-upload-1 file-upload-height"
                  for="customFile "
                >
                  {CertificateLogoPath ? (
                    <img
                      src={CertificateLogoPath}
                      alt="img"
                      className="img-upload-size-1"
                    />
                  ) : (
                    <p className="mb-0">Add Image</p>
                  )}
                  <div className="file-upload-3 ">
                    <i className="ion ion-md-camera  fa-sm"></i>
                  </div>
                </label>
              </div>
              {CertificateLogoFileError.length > 0 ? (
                <p
                  className="mb-0 mt-2"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginLeft: "10px",
                  }}
                >
                  {CertificateLogoFileError}
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="form-group row m-b-15">
            <h5 className="col-md-3 col-form-label mb-0">Document</h5>
            <div className="col-md-9">
              <div class="custom-file ">
                <input
                  type="file"
                  onChange={(e) => CertificatesetFileDocument(e)}
                  className="custom-file-input "
                  id="customFile"
                  accept="application/pdf"
                />
                <label
                  className="custom-file-label file-upload"
                  for="customFile "
                >
                  Upload
                </label>
              </div>
              {DocumentFileError.length > 0 ? (
                <span
                  style={{
                    color: "red",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginLeft: "10px",
                  }}
                >
                  {DocumentFileError}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>

          {CertificateDocumentpath.map((subscriber, index) => (
            <div className="form-group row m-b-15 align-items-center">
              <div
                className="offset-3 col-md-2"
                key={index}
                onClick={() => downloadDocumentData(subscriber.FileUrl)}
              >
                <img
                  src="../assets/img/new-Images/Pdf.png"
                  style={{ height: "60px" }}
                ></img>
              </div>
              <div className="col-md-5">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Name"
                  value={subscriber.FileName}
                  onChange={(e) => {
                    DcoumnetNameEdit(e, index);
                  }}
                />
              </div>
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-sm btn-danger shadow-add  "
                  onClick={(e) => {
                    ondeleteDocumentFile(subscriber._id, index);
                  }}
                >
                  <i className="fas fa-lg fa-fw  fa-trash-alt"></i>
                </button>
              </div>
            </div>
          ))}
          <div className="form-group row m-b-15">
            <h5 className="col-form-label col-md-3 mb-0">Website</h5>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Web site"
                value={CertificateWebsite}
                onChange={onChangeWebsiteName}
              />
              {CertificateWebsiteError.length > 0 ? (
                <span
                  style={{
                    color: "red",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginLeft: "10px",
                  }}
                >
                  {CertificateWebsiteError}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-3"></div>
            <div className="col-md-9">
              <button
                type="button"
                onClick={() => {
                  createDocument();
                }}
                className="btn btn-primary shadow-add mr-2"
              >
                Save
              </button>
              <button
                type="button"
                onClick={() => {
                  toggleSignupAdd();
                }}
                className="btn btn-danger shadow-add  m-r-10"
              >
                Discard
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalSignupEdit} toggle={toggleSignupEdit}>
        <ModalHeader toggle={toggleSignupEdit} className="modalheader">
          <h4 className="text-white mb-0">Edit Certificates</h4>
        </ModalHeader>
        <ModalBody className="m-0">
          <div className="form-group row m-b-15">
            <h5 className="col-md-3 col-form-label mb-0">Certificates Name</h5>
            <div className="col-md-9">
              <input
                type="text"
                maxLength={40}
                className="form-control"
                placeholder="Enter Name"
                value={CertificateName}
                onChange={onChangeCertificateName}
              />
              <p
                style={{
                  textAlign: "right",
                  fontSize: 12,
                  color: "red",
                }}
              >
                {CertificateName.length}/40
              </p>
              {CertificateNameError.length > 0 ? (
                <span
                  style={{
                    color: "red",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginLeft: "10px",
                  }}
                >
                  {CertificateNameError}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className=" row m-b-15">
            <h5 className="col-md-3 mb-0">Logo</h5>
            <div className="col-md-9">
              <div class="custom-file file-upload-height">
                <input
                  type="file"
                  onChange={(e) => CertificatesetFile(e)}
                  className="custom-file-input file-upload-height"
                  id="customFile"
                />
                <label
                  className=" file-upload-1 file-upload-height"
                  for="customFile "
                >
                  <img
                    src={CertificateLogoPath}
                    alt="img"
                    className="img-upload-size-1"
                  />
                  <div className="file-upload-3 ">
                    <i className="ion ion-md-camera  fa-sm"></i>
                  </div>
                </label>
              </div>
              {CertificateLogoFileError.length > 0 ? (
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginLeft: "10px",
                  }}
                >
                  {CertificateLogoFileError}
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="form-group row m-b-15">
            <h5 className="col-md-3 col-form-label mb-0">Document</h5>
            <div className="col-md-9">
              <div class="custom-file ">
                <input
                  type="file"
                  onChange={(e) => CertificatesetFileDocument(e)}
                  className="custom-file-input "
                  id="customFile"
                  accept="application/pdf"
                />
                <label
                  className="custom-file-label file-upload"
                  for="customFile "
                >
                  Upload
                </label>
              </div>
              {DocumentFileError.length > 0 ? (
                <span
                  style={{
                    color: "red",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginLeft: "10px",
                  }}
                >
                  {DocumentFileError}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>

          {CertificateDocumentpath.map((subscriber, index) => (
            <div className="form-group row m-b-15 align-items-center">
              <div
                className="offset-3 col-md-2"
                key={index}
                onClick={() => downloadDocumentData(subscriber.FileUrl)}
              >
                <img
                  src="../assets/img/new-Images/Pdf.png"
                  style={{ height: "60px" }}
                ></img>
              </div>
              <div className="col-md-5">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Name"
                  value={subscriber.FileName}
                  onChange={(e) => {
                    DcoumnetNameEdit(e, index);
                  }}
                />
              </div>
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-sm btn-danger shadow-add  "
                  onClick={(e) => {
                    ondeleteDocumentFile(subscriber._id, index);
                  }}
                >
                  <i className="fas fa-lg fa-fw  fa-trash-alt"></i>
                </button>
              </div>
            </div>
          ))}
          <div className="form-group row m-b-15">
            <h5 className="col-form-label col-md-3">Website</h5>
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Name"
                value={CertificateWebsite}
                onChange={onChangeWebsiteName}
              />
              {CertificateWebsiteError.length > 0 ? (
                <span
                  style={{
                    color: "red",
                    fontSize: "12px",
                    fontWeight: "500",
                    marginLeft: "10px",
                  }}
                >
                  {CertificateWebsiteError}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-3"></div>
            <div className="col-md-9">
              <button
                type="button"
                onClick={() => {
                  UpdateCertificate();
                }}
                className="btn btn-primary shadow-add mr-2"
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-danger shadow-add  m-r-10"
              >
                Discard
              </button>
            </div>
          </div>
        </ModalBody>
        {/* <ModalFooter>
                    <button type="button" onClick={() => { UpdateCertificate() }} className="btn btn-primary shadow-add">Update</button>
                    <button type="button" className="btn btn-danger shadow-add  m-r-10">Discard</button>
                </ModalFooter> */}
      </Modal>
    </div>
  );
};
export default ProfileCertificatesList;
